export enum ImageFitEnum {
    COVER = 'cover',
    CONTAIN = 'contain',
}

export interface ImageFittable {
    imageFit?: ImageFitEnum;
}
